import { Injectable } from "@angular/core";
import { HttpHeaders, HttpClient } from "@angular/common/http";

import { Catalog, CatalogRequest, PageLayout } from "../data/catalog";
import { ListingCartItem, Customer } from "shopping/cart";
import { LayoutService } from "./layout.service";
import { RemoteDataService } from "@nowinstore/nowinstore-core-ui/components";
import { PAGE_LAYOUT_API_URL } from "@app/data/const";
import { Page } from "@app/data/page";
const CDN_URL = "https://cdn.nowinstore.com";

@Injectable()
export class CatalogService {
  httpHeaders = new HttpHeaders({ "Content-Type": "application/json" });
  catalogsUrl = "api/v2/catalogs";

  constructor(
    private httpClient: HttpClient,
    private remoteDataService: RemoteDataService
  ) {}

  getCatalogs(keywords: string, page: number): Promise<Catalog[]> {
    let url = `${this.catalogsUrl}?keywords=${keywords}&page=${page}&limit=300`;
    return this.httpClient
      .get(url)
      .toPromise()
      .then((response) => this.enhanceCatalogsFields(response as Catalog[]))
      .catch(this.handleError);
  }
  getCatalogsCount(): Promise<number> {
    let url = `${this.catalogsUrl}/count`;
    return this.httpClient
      .get(url)
      .toPromise()
      .then((response) => response as number)
      .catch(this.handleError);
  }

  getTemplates(page: number, query: string): Promise<Catalog[]> {
    let url = `${this.catalogsUrl}/templates?page=${page}`;
    if (query) {
      url += `&query=${query}`;
    }
    return this.httpClient
      .get(url)
      .toPromise()
      .then((response) => this.enhanceCatalogsFields(response as Catalog[]))
      .catch(this.handleError);
  }

  getCatalog(id: string): Promise<Catalog> {
    const url = `${this.catalogsUrl}/${id}`;
    return this.httpClient
      .get(url)
      .toPromise()
      .then(
        async (response) => await this.enhanceCatalogFields(response as Catalog)
      )
      .catch(this.handleError);
  }

  delete(id: string): Promise<void> {
    const url = `${this.catalogsUrl}/${id}`;
    return this.httpClient
      .delete(url, { headers: this.httpHeaders })
      .toPromise()
      .then(() => null)
      .catch(this.handleError);
  }

  create(catalog: Catalog): Promise<Catalog> {
    const url = `${this.catalogsUrl}`;
    return this.httpClient
      .post(url, catalog, { headers: this.httpHeaders })
      .toPromise()
      .then((res) => res as Catalog)
      .catch(this.handleError);
  }

  sendRequest(catalogRequest: CatalogRequest): Promise<void> {
    const url = `${this.catalogsUrl}/request`;
    return this.httpClient
      .post(url, catalogRequest, { headers: this.httpHeaders })
      .toPromise()
      .then((res) => null)
      .catch(this.handleError);
  }

  update(catalog: Catalog): Promise<Catalog> {
    const url = `${this.catalogsUrl}/${catalog.id}`;
    return this.httpClient
      .put(url, JSON.stringify(catalog), { headers: this.httpHeaders })
      .toPromise()
      .then(() => catalog)
      .catch(this.handleError);
  }

  copy(catalog: Catalog): Promise<Catalog> {
    const url = `${this.catalogsUrl}/${catalog._id}/copy`;
    return this.httpClient
      .post(url, catalog, { headers: this.httpHeaders })
      .toPromise()
      .then((res) => res as Catalog)
      .catch(this.handleError);
  }
  thumbnailUrl(url: string): string {
    var re = /(https|http)?:\/\/[^\/]*\/[^\/]*\/(.*)/;
    var m;
    var path;
    if ((m = re.exec(url)) !== null) {
      path = m[2];
      url = CDN_URL + "/fit-h300/" + path;
    }
    return url;
  }
  async enhanceCatalogFields(catalog: Catalog) {
    catalog.updated_at = new Date(catalog.updated_at);
    if (catalog.pages.length > 0) {
      var firstPage = catalog.pages[0];
      var elements = firstPage.elements;
      if (elements) {
        var index = 0;
        var max = -1;
        const firstLayout: PageLayout = (<any>firstPage.layout)._id
          ? (firstPage.layout as PageLayout)
          : await this.remoteDataService.get<PageLayout>(
              PAGE_LAYOUT_API_URL,
              firstPage.layout as string
            );
        while (index < elements.length && index < firstLayout?.cells.length) {
          console.log("in while");
          const cell = firstLayout.cells[index];
          const surface = cell.width * cell.height;
          const element = elements[index];
          if (!cell.lock && element?.type === "image/*" && surface > max) {
            const imageUrl = element.properties.url;
            if (imageUrl) {
              console.log(imageUrl);
              catalog.frontCover = imageUrl.includes(".svg")
                ? imageUrl
                : this.thumbnailUrl(imageUrl);
              max = surface;
            }
          }
          index++;
        }
      }
    }
    return catalog;
  }

  enhanceCatalogsFields(catalogs: Catalog[]): Catalog[] {
    for (let catalog of catalogs) {
      this.enhanceCatalogFields(catalog);
    }

    return catalogs;
  }

  handleError(error: any): Promise<any> {
    console.error("An error occurred", error);
    return Promise.reject(error.message || error);
  }
}
